<template>
  <!-- Header -->
  <div class="bg-white z-50 sticky w-full -top-1 print:hidden">
    <div class="w-full mx-auto md:max-w-7xl justify-center p-4">
      <div class="flex flex-wrap justify-between items-center">
        <a :href="'/' + switchBlogLocale()" @click.prevent="goHome" class="flex items-center">
          <NuxtImg
            loading="lazy"
            src="/img/logo.svg"
            class="w-44 md:w-52 lg:w-60 max-w-full"
            alt="Better2Know"
            width="300"
            height="50"
          />
        </a>
      </div>
    </div>
  </div>

  <!-- Content -->
  <main class="min-h-screen mb-20">
    <slot />
  </main>

  <!-- Footer -->
  <CheckoutFooter class="print:hidden" />
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();

const goHome = () => {
  const locale = switchBlogLocale();
  return reloadNuxtApp({ path: `/${locale}/` });
};

addAnalytics(globalStore.siteSettings.google_analytics_4_id);
addGTMAnalytics(globalStore.siteSettings.google_tag_manager_id);
</script>
